const { lazy } = require("react");

const Dashboard = lazy(() => import("../screens/Dashboard/index"));
const Merchants = lazy(() => import("../screens/Merchants/index"));
const LoyaltyCards = lazy(() => import("../screens/LoyaltyCards/index"));
const LoyaltyPrograms = lazy(() => import("../screens/LoyaltyPrograms/index"));
const LoyaltyVerification = lazy(() => import("../screens/LoyaltyVerification/index"));
const MerchantDeposits = lazy(() =>
  import("../screens/MerchantDeposits/index")
);
const Settings = lazy(() => import("../screens/Settings"));
const Transactions = lazy(() => import("../screens/Transactions"));
const Payouts = lazy(() => import("../screens/Payouts"));
const Tills = lazy(() => import("../screens/Tills"));
const Event = lazy(() => import("../screens/Events"));
const Posts = lazy(() => import("../screens/Posts"));
const Feed = lazy(() => import("../screens/Feed"));
const CreateFeed = lazy(() => import("../screens/Feed/CreateFeed"));
const Polls = lazy(() => import("../screens/Polls/index"));
const StreamsLayout = lazy(() => import("../screens/Streams/StreamsLayout"));
const Parking = lazy(() => import("../screens/Parking/index"));
const Influencer = lazy(() => import("../screens/Influencer"));
const Subscriptions = lazy(() =>
  import("../screens/LoyaltyCards/Subscriptions")
);
const SubscriptionDetails = lazy(() =>
  import("../screens/LoyaltyCards/SubscriptionDetails")
);

const routes = [
  {
    path: "/",
    exact: true,
    component: Dashboard,
    name: "Dashboard",
  },
  {
    path: "/dashboard",
    exact: true,
    component: Dashboard,
    name: "Dashboard",
  },
  {
    path: "/merchants",
    exact: false,
    component: Merchants,
    name: "Merchants",
  },
  {
    path: "/loyalty-cards",
    exact: false,
    component: LoyaltyCards,
    name: "LoyaltyCards",
  },
  {
    path: "/loyalty-programs",
    exact: false,
    component: LoyaltyPrograms,
    name: "LoyaltyPrograms",
  },
  {
    path: "/merchant-deposits",
    exact: false,
    component: MerchantDeposits,
    name: "MerchantDeposits",
  },
  {
    path: "/influencer",
    exact: true,
    component: Influencer,
    name: "Influencer",
  },
  {
    path: "/loyalty-verification",
    exact: true,
    component: LoyaltyVerification,
    name: "LoyaltyVerification",
  },
  {
    path: "/settings",
    exact: false,
    component: Settings,
    name: "Settings",
  },
  {
    path: "/subscriptions",
    exact: false,
    component: Subscriptions,
    name: "Subscriptions",
  },
  {
    path: "/subscription/detail/:id/:name",
    exact: true,
    component: SubscriptionDetails,
    name: "Subscriptions",
  },
  {
    path: "/transactions",
    exact: false,
    component: Transactions,
    name: "Transactions",
  },
  {
    path: "/tills",
    exact: false,
    component: Tills,
    name: "Tills",
  },
  {
    path: "/payouts",
    exact: false,
    component: Payouts,
    name: "Payouts",
  },
  {
    path: "/events",
    exact: false,
    component: Event,
    name: "Events",
  },
  {
    path: "/posts",
    exact: false,
    component: Posts,
    name: "Posts",
  },
  {
    path: "/feed",
    exact: true,
    component: Feed,
    name: "Feed",
  },
  {
    path: "/feed/create",
    exact: true,
    component: CreateFeed,
    name: "CreateFeed",
  },
  {
    path: "/polls",
    exact: true,
    component: Polls,
    name: "Polls",
  },
  {
    path: "/streams",
    exact: false,
    component: StreamsLayout,
    name: "Streams",
  },
  {
    path: "/parking",
    exact: false,
    component: Parking,
    name: "Parking",
  },
];

export default routes;
